<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t1">The Setup</span></p>
<p class="p0">By Ofelia Gränd</p>
<p class="p2"><a id="a3"></a><a href="#/005#a12">Chapter 1</a></p>
<p class="p2"><span href="#/006#a17" title="Link target outside of Sample">Chapter 2</span></p>
<p class="p2"><span href="#/007#a21" title="Link target outside of Sample">Chapter 3</span></p>
<p class="p2"><span href="#/008#a24" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p2"><span href="#/009#a26" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p2"><span href="#/010#a28" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p2"><span href="#/011#a29" title="Link target outside of Sample">Epilogue</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?2640ecac